import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.css']
})
export class EmployeeDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    // this.empData = localStorage.getItem('empData');
    // //console.log(this.empData);

    // this.activeroute.queryParams.subscribe(params => {
      // this.loader = true;
      // this.userId = params['user_id'];
      // alert(this.userId);
    // })
  }

}
